import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useStore } from "../store/Store";
import { ValidatorForm } from "react-material-ui-form-validator";
import { TextField } from "@material-ui/core";

const getEmptyModal = (): System.ModalProps => {
  return {
    open: false,
    title: "",
    btn1Text: "",
    btn1Color: undefined,
    btn1OnClick: undefined,
    btn2Text: "",
    btn2Color: undefined,
    btn2OnClick: undefined,
    inputs: undefined,
    shouldRedirect: false,
    text: "",
  };
};

const AlertModal = (props: any) => {
  const { dispatch, state } = useStore();
  const {
    btn1Text,
    btn1Color,
    btn1OnClick,
    btn2Text,
    btn2Color,
    btn2OnClick,
  } = state.modalProps;

  const [inputs, setInputs] = useState<{ [id: string]: System.ModalInput }>(
    state.modalProps.inputs || {}
  );
  useEffect(() => {
    setInputs(state.modalProps.inputs || {});
  }, [state.modalProps.inputs]);

  const handleClose = () => {
    dispatch({ type: "SET_MODAL_PROPS", modalProps: getEmptyModal() });
    // window.location.href = "/"; //TO DO: improve here
  };

  return (
    <div>
      <Dialog
        open={state.modalProps.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {state.modalProps.title}
        </DialogTitle>
        <DialogContent style={{ minWidth: "400px" }}>
          {state.modalProps.text && (
            <DialogContentText id="alert-dialog-description">
              {state.modalProps.text}
            </DialogContentText>
          )}

          <ValidatorForm onSubmit={() => null}>
            {Object.keys(inputs).map((id: string) => {
              switch (inputs[id].type) {
                case "text":
                  return (
                    <div key={id}>
                      <TextField
                        label={inputs[id].label}
                        value={inputs[id].value}
                        style={{ width: "100%" }}
                        margin="normal"
                        onChange={(event) =>
                          setInputs({
                            ...inputs,
                            [id]: { ...inputs[id], value: event.target.value },
                          })
                        }
                        variant="outlined"
                      />
                    </div>
                  );
                default:
                  return null;
              }
            })}
          </ValidatorForm>
        </DialogContent>
        <DialogActions style={{ margin: "1em" }}>
          {btn1Text && (
            <Button
              onClick={() => {
                dispatch({
                  type: "SET_MODAL_PROPS",
                  modalProps: getEmptyModal(),
                });
                if (btn1OnClick) btn1OnClick(inputs);
              }}
              variant="contained"
              color={btn1Color || "primary"}
              autoFocus
            >
              {btn1Text}
            </Button>
          )}
          {btn2Text && (
            <Button
              onClick={() => {
                dispatch({
                  type: "SET_MODAL_PROPS",
                  modalProps: getEmptyModal(),
                });
                if (btn2OnClick) btn2OnClick(inputs);
              }}
              variant="contained"
              color={btn2Color || "primary"}
              autoFocus
            >
              {btn2Text}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertModal;
